<template>
  <div class="MapMigrateConfiger">
    <div class="p-line"></div>
    <div class="p-name">地图迁徙图配置</div>
    <div class="p-grid">
      <!-- 是否开启迁徙图 -->
      <div class="map-m">
        <div class="m-name">是否开启迁徙图</div>
        <el-switch v-model="mapConfig.isShowMigrate" active-color="#1989fa" size="mini" inactive-color="#333">
        </el-switch>
      </div>
      <!-- 选择中心点 -->
      <div class="map-center" v-show="mapConfig.isShowMigrate">
        <div class="name">选择中心点</div>
        <el-select
          v-model="mapConfig.centerCityCode"
          size="mini"
          placeholder="请选择"
          @change="handleCityChange"
        >
          <el-option
            v-for="item in migrateCoodsOptions"
            :key="item.value"
            :label="item.label"
            :value="item.cityCode"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 是否开启右侧柱状图 -->
      <div class="map-chart">
        <div class="name">是否开启右侧柱状图</div>
        <el-switch
          v-model="mapConfig.isShowRightChart"
          active-color="#1989fa"
          size="mini"
          inactive-color="#333"
        >
        </el-switch>
      </div>
      <!-- 地图缩放倍数-->
      <div class="map-chart">
        <div class="name">地图缩放倍数</div>
        <el-input 
          size="mini" 
          v-model="mapConfig.zoom" 
          placeholder="">
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
import provinceCoods from '../../charts/EarthCharts/Earth1Charts/provinceCoordinate';
export default {
  name: 'MapMigrateConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  watch: {
    asyncMapMigrate:{
      deep: true,
      handler: function (nV){
        this.mapConfig.zoom = nV?.value?.zoom || 1.1
        // this.initCurrentPropertyData();
      }
    },
    mapConfig: {
      deep: true,
      handler: function (newVal) {
        this.commitCurrentPropertyData(newVal);
      },
    },
  },
  computed: {
    asyncMapMigrate () {
      return this.$store.state.CurrentConfigration.propertyData?.mapMigrate;
    },
  },
  data() {
    return {
      // 地图配置，包括迁徙图是否渲染，右侧图表是否渲染
      mapConfig: {
        isShowMigrate: Boolean,
        centerCoordinate: null,
        centerCityCode: Number,
        isShowRightChart: Boolean,
      },
      migrateCoodsOptions: [], // 迁徙图坐标配置
      // mapCenterCoordinateCode: Number, // 城市code，直接绑定数组会出问题
    };
  },
  created() {
    this.initCurrentPropertyData();
  },
  mounted() {
    /* 获取初始值 */
    this.initCurrentPropertyData();
    console.log(this.mapConfig.centerCoordinate, '0-0-0-0-0-0-0-');

    this.migrateCoodsOptions = provinceCoods.map(item => {
      return {
        label: item.name,
        value: item.value,
        cityCode: item.cityCode,
      };
    });

    // let cood = this.mapConfig.centerCoordinate;
    // for (let i = 0; i < this.migrateCoodsOptions.length; i++) {
    //   let a = this.migrateCoodsOptions[i];
    //   if (a[0] == cood[0] && a[1] == cood[1]) {
    //     this.mapConfig.centerCoordinate = a;
    //     break;
    //   }
    // }
  },
  methods: {
    initCurrentPropertyData() {
      this.mapConfig = this.$_.cloneDeep(this.propertyData[this.propertyDataKey].value);
      // debugger
    },
    commitCurrentPropertyData(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
    handleCityChange(e) {
      console.log(e, '城市代码');
      this.mapConfig.centerCoordinate = this.migrateCoodsOptions.find(item => {
        return item.cityCode == e;
      }).value;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.MapMigrateConfiger {
  margin-top: 10px;
  height: auto;
  transition: all 0.2s ease-in-out;
  width: 100%;
  box-sizing: border-box;
  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
    margin-bottom: 5px;
  }
  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  .p-grid {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    width: 100%;
    // height: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    align-items: center;
    justify-content: space-between;
    .map-m,
    .map-center,
    .map-chart {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px 0;
    }
    span {
      width: 50px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    .el-input {
      width: 65px;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
:deep().el-switch {
  margin: auto 0;
  .el-switch__core {
    background: #55597b;
    border: none;
    height: 10px;
    width: 30px !important;
    .el-switch__action {
      top: -2px;

      background: #c9cae5;

      width: 14px;
      height: 14px;
    }
  }
  &.is-checked {
    .el-switch__core {
      background: linear-gradient(143deg, #335ae9, #6f6ff5);
      .el-switch__action {
        left: 100%;
        background: #ffffff;
        margin-left: -14px;
      }
    }
  }
}
.el-select {
  width: 150px;

  :deep() input {
    color: #ffffff;
    background: #191b23;
    border-radius: 0;
    border-collapse: collapse;
    text-align: center;
    border: 1px solid rgb(90, 90, 90);

    &:hover {
      border: 1px solid #3179ff;
    }
    &:focus {
      border: 1px solid #3179ff;
    }
  }
}
</style>
